const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { internalTimelineExportSearchSchema } from '@/components/views/export/ExportTimelinePdfPage';

/**
 * Export route for timeline PDF generation with token authentication
 *
 * This route is accessed exclusively by the backend worker using a temporary JWT token.
 * It provides a clean, print-ready rendering of the timeline suitable for Playwright's page.pdf().
 *
 * Authentication: JWT token passed via ?token= query parameter (validated by backend API)
 * URL Pattern: /export/v1/loop-visualization/view/:viewId/visualization/:visualizationId/timeline/pdf?token={jwt}&...
 *
 * Query Parameters:
 * - token (required): JWT export token
 * - title (optional): '0' to hide title
 * - branding (optional): '0' to hide branding
 * - date (optional): '0' to hide publish date
 * - legend (optional): '0' to hide legend
 * - vision (optional): Custom vision statement text
 */
export const Route = createFileRoute('/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf')({
  validateSearch: zodValidator(internalTimelineExportSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    skipDocumentTitle: true
  }
});